// このファイルは自動生成されています
/**
 *  [2024] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambda: preferencemanageにアクセスするためのドライバーコード
 * 設定データのCRUD処理を実施する
 */

import {makeApiCall, createOptions} from '@zettant/commonUtils/comm';
import {awsResources, salt} from '@/awsCodes/resourceParams';
import {getAuthInfo} from '@zettant/awsUtils';
import {IPreference, IResponse} from '../interfaces';


/**
 * Lambda: preferencemanageにアクセスするためのドライバ関数
 * @param needIdToken {boolean}
 * @param cmd {string|undefined}
 * @param records {string|undefined}
 * @param record {IPreference|undefined}
 * @param timestamp {number|undefined}
 * @return Promise<IResponse>
 * @throw {Error} Throws Error object
 */
export const preferencemanageCall = async (needIdToken: boolean, cmd: string|undefined, records: string|undefined, record: IPreference|undefined, timestamp: number|undefined): Promise<IResponse> => {
  // ----PREPARATION-OF-METHOD----
  // ----END-OF-PREPARATION----

  let idToken: string|undefined;
  if (needIdToken) {
    const res: any = await getAuthInfo();
    if (!res) throw new Error('refreshToken expired');
    idToken = res.idToken;
  }

  const restPath = awsResources.baseUrl[`preferencemain${salt}`];
  const makeApiCallOptions = createOptions(idToken, `${restPath}/pref`, {}, {cmd, records, record, timestamp});
  const {response}: any = await makeApiCall(makeApiCallOptions)
    .then((r: any) => ({response: r}))
    .catch((e) => ({error: e}));
  return response;
};


